import React from "react";
import {
  FaArrowRight,
  FaCheck,
  FaEnvelope,
  FaGlobe,
  FaLinkedinIn,
  FaPhoneAlt,
  FaSms,
  FaUserPlus,
  FaWhatsapp,
} from "react-icons/fa";
import { LINKEDIN_JULIAN } from "../data/cfoFraccionalData";
import photoJulian from "../assets/contacto/julian-herrera.jpg";

const CONTACT = {
  firstName: "Julian",
  lastName: "Herrera",
  fullName: "Julian Herrera",
  title: "Dirección General",
  company: "MEU Aliado",
  mobile: "+57 321 321 3635",
  mobileE164: "+573213213635",
  email: "julianherrx@hotmail.com",
  emailWork: "colaboradores@meu-aliado.com",
  website: "https://meu-aliado.com",
  websiteLabel: "meu-aliado.com",
  linkedin: LINKEDIN_JULIAN,
  linkedinLabel: "linkedin.com/in/julian-herrera",
};

function buildVCard() {
  return [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${CONTACT.lastName};${CONTACT.firstName};;;`,
    `FN:${CONTACT.fullName}`,
    `TITLE:${CONTACT.title}`,
    `ORG:${CONTACT.company}`,
    `TEL;TYPE=CELL,VOICE:${CONTACT.mobileE164}`,
    `EMAIL;TYPE=INTERNET,PREF:${CONTACT.email}`,
    `EMAIL;TYPE=INTERNET,WORK:${CONTACT.emailWork}`,
    `URL:${CONTACT.website}`,
    `URL;TYPE=LinkedIn:${CONTACT.linkedin}`,
    "END:VCARD",
  ].join("\r\n");
}

function downloadVCard() {
  const blob = new Blob([buildVCard()], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "Julian-Herrera.vcf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function JulianHerreraCard() {
  return (
    <div className="min-h-screen bg-[#eef4fb] px-4 py-8 sm:py-12">
      <div className="mx-auto w-full max-w-md">
        <div className="relative mt-20 rounded-3xl bg-gradient-to-b from-[#1a4a9e] to-[#0b1f3f] px-6 pb-8 pt-20 text-center text-white shadow-xl">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2">
            <img
              src={`${photoJulian}?v=4`}
              alt={CONTACT.fullName}
              className="h-32 w-32 rounded-full border-4 border-white object-cover object-[50%_18%] shadow-lg"
            />
          </div>
          <h1 className="mt-10 text-2xl font-extrabold tracking-tight">{CONTACT.fullName}</h1>
          <p className="mt-1 text-sm font-medium text-[#9ec5ff]">{CONTACT.title}</p>
          <p className="mt-1 text-xs text-white/70">{CONTACT.company}</p>

          <div className="mt-6 flex items-center justify-center gap-3">
            <a
              href={`tel:${CONTACT.mobileE164}`}
              aria-label="Llamar"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-[#9ec5ff] text-[#0b1f3f] shadow-md transition hover:bg-white"
            >
              <FaPhoneAlt className="h-4 w-4" />
            </a>
            <a
              href={`sms:${CONTACT.mobileE164}`}
              aria-label="SMS"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-[#9ec5ff] text-[#0b1f3f] shadow-md transition hover:bg-white"
            >
              <FaSms className="h-4 w-4" />
            </a>
            <a
              href={`https://wa.me/${CONTACT.mobileE164.replace("+", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-[#9ec5ff] text-[#0b1f3f] shadow-md transition hover:bg-white"
            >
              <FaWhatsapp className="h-5 w-5" />
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              aria-label="Correo"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-[#9ec5ff] text-[#0b1f3f] shadow-md transition hover:bg-white"
            >
              <FaEnvelope className="h-4 w-4" />
            </a>
          </div>
        </div>

        <section className="mt-4 rounded-3xl border-2 border-[#1746a2]/25 bg-white p-5 shadow-sm">
          <div className="mb-4 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 text-[#0b1f3f]">
              <FaPhoneAlt className="h-3.5 w-3.5" />
              <h2 className="text-sm font-bold">Contacto</h2>
            </div>
            <button
              type="button"
              onClick={downloadVCard}
              className="inline-flex items-center gap-2 rounded-full bg-[#1746a2] px-3.5 py-2 text-xs font-bold text-white shadow-sm transition hover:bg-[#123a72]"
            >
              <FaUserPlus className="h-3.5 w-3.5" />
              Guardar contacto
            </button>
          </div>

          <dl className="space-y-3 text-sm">
            <div className="border-b border-slate-100 pb-3">
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Nombre</dt>
              <dd className="mt-1 font-semibold text-[#0b1f3f]">{CONTACT.fullName}</dd>
            </div>
            <div className="border-b border-slate-100 pb-3">
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Cargo</dt>
              <dd className="mt-1 font-semibold text-[#0b1f3f]">{CONTACT.title}</dd>
            </div>
            <div className="border-b border-slate-100 pb-3">
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Celular</dt>
              <dd className="mt-1">
                <a href={`tel:${CONTACT.mobileE164}`} className="font-semibold text-[#1746a2] hover:underline">
                  {CONTACT.mobile}
                </a>
              </dd>
            </div>
            <div className="border-b border-slate-100 pb-3">
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Correo</dt>
              <dd className="mt-1">
                <a href={`mailto:${CONTACT.email}`} className="break-all font-semibold text-[#1746a2] hover:underline">
                  {CONTACT.email}
                </a>
              </dd>
            </div>
            <div className="border-b border-slate-100 pb-3">
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Correo laboral</dt>
              <dd className="mt-1">
                <a href={`mailto:${CONTACT.emailWork}`} className="break-all font-semibold text-[#1746a2] hover:underline">
                  {CONTACT.emailWork}
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Empresa</dt>
              <dd className="mt-1 font-semibold text-[#0b1f3f]">{CONTACT.company}</dd>
            </div>
          </dl>
        </section>

        <section className="mt-4 overflow-hidden rounded-3xl bg-gradient-to-br from-[#0b1f3f] to-[#1746a2] p-6 text-white shadow-lg">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-[#9ec5ff]">
            Dirección de innovación financiera
          </p>
          <h2 className="mt-3 text-xl font-extrabold leading-snug">
            No le faltan datos. Le faltan sistemas para decidir.
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-[#dbeafe]">
            En MEU Aliado impulsamos la adopción tecnológica y armamos sistemas de toma de decisiones
            —en cargos técnicos y en la alta dirección— para que la información se vuelva acción.
          </p>

          <ul className="mt-5 space-y-2.5 text-sm">
            {[
              "Adopción tecnológica que su equipo sí usa.",
              "Sistemas de decisión en lo técnico y en lo ejecutivo.",
              "Dirección financiera que convierte datos en acción.",
            ].map((item) => (
              <li key={item} className="flex items-start gap-2.5">
                <FaCheck className="mt-1 h-3 w-3 shrink-0 text-[#9ec5ff]" />
                <span className="text-[#e8f2ff] leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>

          <div className="mt-6 flex flex-col gap-2.5">
            <a
              href={`https://wa.me/${CONTACT.mobileE164.replace("+", "")}?text=${encodeURIComponent(
                "Hola Julian, vi tu tarjeta y quiero conocer la dirección de innovación financiera de MEU Aliado."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-bold text-[#123a72] transition hover:bg-[#e8f2ff]"
            >
              <FaWhatsapp className="h-4 w-4" />
              Hablemos de su empresa
            </a>
            <a
              href="/empresas/direccion-de-innovacion-financiera"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 px-5 py-3 text-sm font-bold text-white transition hover:bg-white/10"
            >
              Conocer el servicio
              <FaArrowRight className="h-3 w-3" />
            </a>
          </div>
        </section>

        <section className="mt-4 rounded-3xl border-2 border-[#1746a2]/25 bg-white p-5 shadow-sm">
          <div className="mb-4 flex items-center gap-2 text-[#0b1f3f]">
            <FaGlobe className="h-3.5 w-3.5" />
            <h2 className="text-sm font-bold">Enlaces</h2>
          </div>
          <div className="space-y-3 text-sm">
            <a
              href={CONTACT.website}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 font-semibold text-[#1746a2] hover:underline"
            >
              <FaGlobe className="h-3.5 w-3.5 shrink-0" />
              {CONTACT.websiteLabel}
            </a>
            <a
              href={CONTACT.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 font-semibold text-[#1746a2] hover:underline"
            >
              <FaLinkedinIn className="h-3.5 w-3.5 shrink-0" />
              {CONTACT.linkedinLabel}
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default JulianHerreraCard;
